export const fontFamilyVariable = {
    default: '--cronos-font-default',
    heading: '--cronos-font-heading',
};
export const fontFamily = {
    default: `var(${fontFamilyVariable.default})`,
    heading: `var(${fontFamilyVariable.heading})`,
};
